<script setup>
import {useStore} from "vuex";
import {StarFilled} from "@element-plus/icons-vue"
const store = useStore()
</script>

<template>
  <header class="header-box" ref="hh" >
  </header>

</template>

<style  lang="less" scoped>
.header-box {
  display: flex;
  width: 100%;
  height: 1vh;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 19.2px;
  font-weight: bold;

  img {
    width: 40px;
    margin-right: 10px;
  }

  .left {
    display: flex;
    align-items: center;
  }

  .right {
    color: blue;
    font-size: 15px;
    font-weight: normal;
    cursor: pointer;
    text-underline: blue;
    span{
      margin-left: 5px;
    }
  }
}
</style>